import { Outlet } from 'react-router-dom';

export const ContractorEmployeeOutlet = () => <Outlet />;
